import { PRODUCTION_ROOT, siteUrl } from '@inboxkit/env/sites';
import { useSyncExternalStore } from 'react';
import { withUtm } from './analytics';
import { siteEnv } from './env';

export interface SiteUrls {
  api: string;
  app: string;
  status: string;
  pushGuide: string;
  requestAccess: string;
}

function build(from: string | undefined, requestAccess: string): SiteUrls {
  const api = siteUrl('api', { env: siteEnv, ...(from ? { from } : {}) });
  return {
    api,
    app: siteUrl('app', { env: siteEnv, ...(from ? { from } : {}) }),
    status: siteUrl('status', { env: siteEnv, ...(from ? { from } : {}) }),
    pushGuide: `${api}/docs/core-push`,
    requestAccess,
  };
}

// The pre-render has no host, so it links to production. After hydration the
// browser swaps in the URLs for the real host (the same on inboxkit.dev) and
// keeps UTM parameters on Request access links.
const SERVER = build(`https://${PRODUCTION_ROOT}`, '/request-access');
let client: SiteUrls | undefined;
const getClient = () => {
  client ??= build(undefined, withUtm('/request-access'));
  return client;
};
const subscribe = () => () => {};

export function useSiteUrls(): SiteUrls {
  return useSyncExternalStore(subscribe, getClient, () => SERVER);
}
